import { render, staticRenderFns } from "./ClientProfileForm.vue?vue&type=template&id=046cebf1&scoped=true&"
import script from "./ClientProfileForm.vue?vue&type=script&lang=js&"
export * from "./ClientProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046cebf1",
  null
  
)

export default component.exports